<p-drawer
  [(visible)]="visible"
  [position]="position"
  [closable]="false"
  [dismissible]="dismissible"
  [styleClass]="styleClass"
  (visibleChange)="onVisibleChange($event)"
  (onHide)="onCloseClick()"
  [attr.aria-labelledby]="drawerTitle"
  [closeOnEscape]="false"
  [blockScroll]="true"
>
  <ng-template #header />
  <ng-template #content>
    <!-- Wrapper unico con focus trap per includere sia header che content -->
    <div
      pFocusTrap
      class="flex flex-col h-full"
    >
      <!-- Header -->
      <!-- border-b border-[var(--colors-gray-scale-gray-4)]-->
      <div class="flex flex-row justify-between items-center w-full pb-5">
        <div class="flex flex-row items-center gap-2">
          <h3
            [attr.id]="drawerTitle"
            class="text-black text-2xl font-bold flex-1"
            [ngClass]="cssTitleClass"
          >{{ title | translate }}</h3>
          <div *ngIf="headerBadgeSeverity && headerBadgeSeverity !== 'none'">
            <p-badge
              [value]="headerCounterValue"
              [severity]="headerBadgeSeverity"
              styleClass="!rounded-[4px]"
            />
          </div>
        </div>

        <ape-button
          *ngIf="closable"
          [pAutoFocus]="true"
          [variant]="'primary'"
          [aspect]="'icon-outline'"
          [size]="'small'"
          [rightIcon]="'assets/icons/x.svg'"
          [ariaLabel]="TRANSLATION_KEYS.generic.accessibility.DRAWER_CLOSE | translate"
          (buttonClick)="onCloseClick()"
        />
      </div>

      <!-- Content -->
      <div class="flex flex-col gap-5 flex-1 overflow-visible pb-5">
        <ng-content />
      </div>
    </div>
  </ng-template>
</p-drawer>